<template>
  <div v-if="item" class="stat-menu-item-label d-flex align-center">
    <component :is="labelComponent" :href="href" :target="linkTarget">
      <v-img
        v-if="showImage && item.image"
        :width="imageSize"
        :height="imageSize"
        cover
        :src="item.image"
        class="stat-menu-item-label__image"
      ></v-img>
    </component>

    <!--    <div-->
    <!--      v-if="showImage && item.image"-->
    <!--      class="stat-menu-item-label__image"-->
    <!--      :style="{-->
    <!--        backgroundImage: imageBg,-->
    <!--        width: imageSize,-->
    <!--        height: imageSize,-->
    <!--      }"-->
    <!--    >-->
    <!--    </div>-->
    <component :is="labelComponent" class="stat-menu-item-label__name" :href="href" :target="linkTarget">
      {{ item.name }}
    </component>
  </div>
</template>

<script>
  export default {
    name: 'MenuItemLabel',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      imageSize: {
        type: Number,
        default: 45,
      },
      showEditLink: {
        type: Boolean,
        default: false,
      },
      showImage: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      imageBg () {
        return this.item.image ? `url('${this.item.image}')` : null
      },
      labelComponent () {
        return this.showEditLink
          ? 'a'
          : 'div'
      },
      href () {
        return this.showEditLink
          ? this.$router.resolve({ name: 'menuItemEdit', params: { id: this.item.id } }).href
          : null
      },
      linkTarget () {
        return this.showEditLink
          ? '_blank'
          : null
      },
    },
  }
</script>

<style lang="less" scoped>
.stat-menu-item-label {
  padding-top: 7px;
  padding-bottom: 7px;

  &__image {
    margin-right: 15px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #E5E5E5;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: 2px #fff solid;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  }

  &__name {
    display: inline-block;
    color: black;
    text-decoration: none;
    //font-weight: 400;
  }

  a.stat-menu-item-label__name{
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

  }
}
</style>
